import React from 'react';
import AppRouter from 'navigation/Router';

function App(props) {
	return <AppRouter />;
}

export default App;